// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Eligibility Card – Indigo Theme */
.eligibility-card {
  background: radial-gradient(circle at top left, var(--bg-soft), #ffffff);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  padding: 14px 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  animation: eligibility-fade 0.25s ease-out;
  margin-bottom: 1rem;
}

/* Fade-in */
@keyframes eligibility-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Emoji on left */
.eligibility-emoji {
  font-size: 1.45rem;
  margin-top: 2px;
}

/* Text */
.eligibility-text {
  color: var(--text-main);
  font-size: 0.95rem;
  line-height: 1.55;
}

/* Highlight style (indigo soft) */
.highlight {
  background: rgba(99, 102, 241, 0.18);
  padding: 2px 5px;
  border-radius: 6px;
  color: var(--accent-700);
  font-weight: 600;
}

/* Mobile */
@media (max-width: 768px) {
  .eligibility-card {
    padding: 12px 13px;
    border-radius: var(--radius-md);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/EligibilityBox.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,wEAAwE;EACxE,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;IACE,kBAAkB;IAClB,+BAA+B;EACjC;AACF","sourcesContent":["/* Eligibility Card – Indigo Theme */\n.eligibility-card {\n  background: radial-gradient(circle at top left, var(--bg-soft), #ffffff);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  padding: 14px 16px;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  animation: eligibility-fade 0.25s ease-out;\n  margin-bottom: 1rem;\n}\n\n/* Fade-in */\n@keyframes eligibility-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Emoji on left */\n.eligibility-emoji {\n  font-size: 1.45rem;\n  margin-top: 2px;\n}\n\n/* Text */\n.eligibility-text {\n  color: var(--text-main);\n  font-size: 0.95rem;\n  line-height: 1.55;\n}\n\n/* Highlight style (indigo soft) */\n.highlight {\n  background: rgba(99, 102, 241, 0.18);\n  padding: 2px 5px;\n  border-radius: 6px;\n  color: var(--accent-700);\n  font-weight: 600;\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .eligibility-card {\n    padding: 12px 13px;\n    border-radius: var(--radius-md);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
